import { useCallback } from 'react';

import { ApiSectionNamespace } from '@api';
import {
  useHttpClientAwaitable,
  GRAPHQL_HEADER,
  httpMethods,
  IGeneralRequestResponse,
  IGraphQlQuery,
  IHttpHookResponseAwaitable,
} from '@services/httpClientService';

import { IUpdateBenefitsAction } from '../../../context';
import { transformCartBenefits } from '../../mapper';

import { IValidateCartContentResponse } from './model';
import { VALIDATE_CART_CONTENT_MUTATION } from './validateCartContentMutation';

const mappingFunction = (result: IValidateCartContentResponse): IGeneralRequestResponse<IUpdateBenefitsAction> => {
  return {
    ...result.validateCart,
    data: {
      ...result.validateCart.data,
      benefits: transformCartBenefits(result.validateCart.data.benefits),
    },
  };
};

export const useValidateCartAwaitable = (): IHttpHookResponseAwaitable<
  IGeneralRequestResponse<IUpdateBenefitsAction>
> => {
  const { request: awaitableRequest } = useHttpClientAwaitable<
    IGeneralRequestResponse<IUpdateBenefitsAction>,
    IGraphQlQuery,
    IValidateCartContentResponse
  >({
    method: httpMethods.POST,
    path: ApiSectionNamespace.ECartApiKeys.CART_VALIDATE_URL,
    mappingFunction,
    customHeaders: GRAPHQL_HEADER,
  });

  const request = useCallback(() => {
    return awaitableRequest({ data: { query: VALIDATE_CART_CONTENT_MUTATION } });
  }, [awaitableRequest]);

  return { request };
};
